import React, { useState, useEffect } from 'react';
import { MenuItem, Select, IconButton, InputLabel, FormControl, Box, Button, TextField, CircularProgress, FormControlLabel, Checkbox } from "@mui/material";
import { Formik, FieldArray } from "formik";
import * as yup from "yup";
import useMediaQuery from "@mui/material/useMediaQuery";
import Header from "../../../components/Header";
import axios from 'axios';
import { useNavigate } from "react-router-dom";
import { Remove } from "@mui/icons-material";

const RegisterCliente = () => {
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [colaboradores, setColaboradores] = useState([]);

  const handleFormSubmit = async (values, actions) => {
    console.log("Formulário submetido"); 
    const payload = {
      numCliente: values.numCliente,
      grupoI: values.grupoI,
      grupoII: values.grupoII,
      nif: values.nif,
      nomeCliente: values.nomeCliente,
      vinculo: values.vinculo,
      mandatos: values.mandatos,
      periodo: values.periodo,
      socio: values.socio,
      aprovador1: values.aprovador1,
      aprovador2: values.aprovador2,
      faturado: values.faturado, // Incluir faturado no payload
    };
    console.log("Payload enviado:", payload); // Verifique se os dados estão corretos
    setLoading(true);
    try {
      const response = await axios.post(`https://pf-auditores.ew.r.appspot.com/api/clientes`, payload);
      console.log("Cliente registrado com sucesso:", response.data);
      actions.resetForm();
      navigate("/clientes");  // Verifique se o redirecionamento ocorre corretamente
    } catch (error) {
      console.error("Erro ao registrar cliente:", error); // Verifique se há erros de requisição
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [colaboradoresResponse] = await Promise.all([
          axios.get('https://pf-auditores.ew.r.appspot.com/api/colaboradores')
        ]);
        setColaboradores(colaboradoresResponse.data);
      } catch (error) {
        console.error('Erro ao buscar colaboradores:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  // Função para obter o primeiro e último nome
  const getFirstAndLastName = (fullName) => {
    const nomeAbreviado = fullName.split(' ');
    return `${nomeAbreviado[0]} ${nomeAbreviado[nomeAbreviado.length - 1]}`;
  };

  return (
    <Box m="20px">
      <Header title="Registrar Cliente" subtitle="Registrar novo cliente" />
      
      <Formik
        onSubmit={handleFormSubmit}
        initialValues={initialValues}
        validationSchema={checkoutSchema}
      >
        {({
          values,
          errors,
          touched,
          handleBlur,
          handleChange,
          handleSubmit,
        }) => (
          <form onSubmit={handleSubmit}>
            <Box
              display="grid"
              gap="30px"
              gridTemplateColumns="repeat(4, minmax(0, 1fr))"
              sx={{
                "& > div": { gridColumn: isNonMobile ? undefined : "span 4" },
              }}
            >
              <TextField
                label="Número do Cliente"
                name="numCliente"
                value={values.numCliente}
                onChange={handleChange}
                fullWidth
                variant="filled"
                error={!!touched.numCliente && !!errors.numCliente}
                helperText={touched.numCliente && errors.numCliente}
                sx={{ gridColumn: "span 1" }}
              />
              <TextField
                label="Grupo I"
                name="grupoI"
                value={values.grupoI}
                onChange={handleChange}
                fullWidth
                variant="filled"
                error={!!touched.grupoI && !!errors.grupoI}
                helperText={touched.grupoI && errors.grupoI}
                sx={{ gridColumn: "span 1" }}
              />
              <TextField
                label="Grupo II"
                name="grupoII"
                value={values.grupoII}
                onChange={handleChange}
                fullWidth
                variant="filled"
                error={!!touched.grupoII && !!errors.grupoII}
                helperText={touched.grupoII && errors.grupoII}
                sx={{ gridColumn: "span 1" }}
              />
              <TextField
                label="NIF"
                name="nif"
                value={values.nif}
                onChange={handleChange}
                fullWidth
                variant="filled"
                error={!!touched.nif && !!errors.nif}
                helperText={touched.nif && errors.nif}
                sx={{ gridColumn: "span 1" }}
              />
              <TextField
                label="Nome do Cliente"
                name="nomeCliente"
                value={values.nomeCliente}
                onChange={handleChange}
                fullWidth
                variant="filled"
                error={!!touched.nomeCliente && !!errors.nomeCliente}
                helperText={touched.nomeCliente && errors.nomeCliente}
                sx={{ gridColumn: "span 1" }}
              />
              <FormControl variant="filled" fullWidth sx={{ gridColumn: "span 1" }}>
                <InputLabel>Aprovador 1</InputLabel>
                <Select
                  name="aprovador1"
                  value={values.aprovador1}
                  onBlur={handleBlur}
                  onChange={handleChange}
                  error={!!touched.aprovador1 && !!errors.aprovador1}
                >
                  {colaboradores
                    .filter(colaborador => colaborador.tipo === 'ADMIN')
                    .map(colaborador => (
                      <MenuItem key={colaborador.id} value={colaborador.id}>
                        {getFirstAndLastName(colaborador.nome)}
                      </MenuItem>
                    ))}
                </Select>
                {touched.aprovador1 && errors.aprovador1 && (
                  <div style={{ color: 'red', marginTop: 8 }}>{errors.aprovador1}</div>
                )}
              </FormControl>
              <FormControl variant="filled" fullWidth sx={{ gridColumn: "span 1" }}>
                <InputLabel>Aprovador 2</InputLabel>
                <Select
                  name="aprovador2"
                  value={values.aprovador2}
                  onBlur={handleBlur}
                  onChange={handleChange}
                  error={!!touched.aprovador2 && !!errors.aprovador2}
                >
                  {colaboradores
                    .filter(colaborador => colaborador.tipo === 'ADMIN')
                    .map(colaborador => (
                      <MenuItem key={colaborador.id} value={colaborador.id}>
                        {getFirstAndLastName(colaborador.nome)}
                      </MenuItem>
                    ))}
                </Select>
                {touched.aprovador2 && errors.aprovador2 && (
                  <div style={{ color: 'red', marginTop: 8 }}>{errors.aprovador2}</div>
                )}
              </FormControl>
              <FormControl variant="filled" fullWidth sx={{ gridColumn: "span 1" }}>
                <InputLabel>Vínculo</InputLabel>
                <Select
                  name="vinculo"
                  value={values.vinculo}
                  onBlur={handleBlur}
                  onChange={handleChange}
                  error={!!touched.vinculo && !!errors.vinculo}
                >
                  <MenuItem value="Consultoria">Consultoria</MenuItem>
                  <MenuItem value="Auditoria">Auditoria</MenuItem>
                </Select>
                {touched.vinculo && errors.vinculo && (
                  <div style={{ color: 'red', marginTop: 8 }}>{errors.vinculo}</div>
                )}
              </FormControl>
              <TextField
                label="Sócio"
                name="socio"
                value={values.socio}
                onChange={handleChange}
                fullWidth
                variant="filled"
                error={!!touched.socio && !!errors.socio}
                helperText={touched.socio && errors.socio}
                sx={{ gridColumn: "span 1" }}
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={values.faturado}
                    onChange={handleChange}
                    name="faturado"
                  />
                }
                label="Faturado"
                sx={{ gridColumn: "span 1" }}
              />
              <TextField
                label="Mandato"
                name="periodo"
                value={values.periodo}
                onChange={handleChange}
                fullWidth
                variant="filled"
                error={!!touched.periodo && !!errors.periodo}
                helperText={touched.periodo && errors.periodo}
                sx={{ gridColumn: "span 1" }}
              />
              {/* Mandatos */}
              <FieldArray name="mandatos">
                {({ push, remove }) => (
                  <Box sx={{ gridColumn: "span 3" }}>
                    {values.mandatos.map((mandato, index) => (
                      <Box key={index} display="flex" gap="10px" mb={2}>
                        <TextField
                          label="Ano"
                          name={`mandatos[${index}].ano`}
                          value={mandato.ano}
                          onChange={handleChange}
                          fullWidth
                          variant="filled"
                          error={!!(touched.mandatos?.[index]?.ano && errors.mandatos?.[index]?.ano)}
                          helperText={touched.mandatos?.[index]?.ano && errors.mandatos?.[index]?.ano}
                        />
                        <TextField
                          label="Honorários"
                          name={`mandatos[${index}].honorario`}
                          value={mandato.honorario}
                          onChange={handleChange}
                          fullWidth
                          variant="filled"
                          error={!!(touched.mandatos?.[index]?.honorario && errors.mandatos?.[index]?.honorario)}
                          helperText={touched.mandatos?.[index]?.honorario && errors.mandatos?.[index]?.honorario}
                        />
                        <IconButton onClick={() => remove(index)}>
                          <Remove />
                        </IconButton>
                      </Box>
                    ))}
                    <Button
                      type="button"
                      variant="contained"
                      onClick={() => push({ ano: "", honorario: "" })}
                      sx={{ mt: 2 }}
                    >
                      Adicionar Mandato
                    </Button>
                  </Box>
                )}
              </FieldArray>
            </Box>
            <Box sx={{ gridColumn: "span 4", display: 'flex', justifyContent: 'space-between', mt: 2 }}>
              <Button variant="contained" color="primary" onClick={() => navigate("/clientes")}>
                Voltar
              </Button>
              <Button variant="contained" color="secondary" type="submit" disabled={loading}>
                {loading ? <CircularProgress size={24} color="secondary" /> : 'Guardar'}
              </Button>
            </Box>
          </form>
        )}
      </Formik>
    </Box>
  );
};

const checkoutSchema = yup.object().shape({
  numCliente: yup.string().required("Número do Cliente é obrigatório"),
  grupoI: yup.string().required("Grupo I é obrigatório"),
  grupoII: yup.string().required("Grupo II é obrigatório"),
  nif: yup.string().required("NIF é obrigatório"),
  nomeCliente: yup.string().required("Nome do Cliente é obrigatório"),
  vinculo: yup.string().required("Vínculo é obrigatório"),
  periodo: yup.string().required("Mandato é obrigatório"),
  socio: yup.string().required("Sócio é obrigatório"),
  aprovador1: yup.string().required("Aprovador 1 é obrigatório"),
  aprovador2: yup.string().required("Aprovador 2 é obrigatório"),
  mandatos: yup.array().of(
    yup.object().shape({
      ano: yup.string().required("Ano é obrigatório"),
      honorario: yup.number().required("Honorários são obrigatórios"),
    })
  ).min(1, "É necessário pelo menos um mandato"),
  faturado: yup.boolean().required("Campo Faturado é obrigatório"),
});

const initialValues = {
  numCliente: "",
  grupoI: "",
  grupoII: "",
  nif: "",
  nomeCliente: "",
  vinculo: "",  // Inicializa com uma string vazia ou um valor padrão se desejar
  socio: "",
  aprovador1: "",
  aprovador2: "",
  faturado: false, // Inicializa faturado como false
  mandatos: [
    {
      ano: "",
      honorario: "",
    }
  ],
};

export default RegisterCliente;
